<template>
  <div class="page" ref="container">
    <nav-bar
      title="我的档案"
      left-text="返回"
      left-arrow
      @click-left="goBack"
      :fixed="false"
      :placeholder="true"
    />
    <cell-group title="基本信息">
      <cell title="姓名" :value="info.trueName" />
      <cell title="昵称" :value="info.nickname" />
      <cell title="电话" :value="info.phone" />
      <cell title="性别" :value="info.sex == 0 ? '女' : '男'" />
      <cell title="生日" :value="info.birthDay" />
      <cell title="顾问" :value="info.waiterName" />
      <cell title="地址" :value="info.address" />
    </cell-group>

    <cell-group title="宝宝信息" v-if="info.babyName">
      <cell title="姓名" :value="info.babyName" />
      <cell title="性别" :value="info.babySex == 0 ? '小仙女' : '小王子'" />
      <cell title="生日" :value="info.babyBirth" />
    </cell-group>

    <cell-group title="账户信息">
      <cell title="我的余额" :value="info.money || 0" />
      <cell title="剩余次数" :value="arrivalData.surplusNum || 0" />
      <cell title="消费次数" :value="arrivalData.consumeNum || 0" />
    </cell-group>
  </div>
</template>
<script>
import { NavBar, Cell, CellGroup } from "vant";
import { getUserInfo, getArrivalData } from "@api/user";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  components: {
    Cell,
    CellGroup,
    NavBar,
  },
  props: {},
  data: function () {
    return {
      info: {},
      arrivalData: {},
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    userInfo: {
      handler(val, oldVal) {
        this.init();
      },
    },
  },
  mounted: function () {
    this.init();
  },
  methods: {
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    init: function () {
      getUserInfo().then((res) => {
        this.info = res.result;
      });
      this.getArrival();
    },
    getArrival: function () {
      let that = this;
      getArrivalData().then((res) => {
        that.arrivalData = res.result;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
}
</style>
